import {
    DataRecord,
    getMetricLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, GaugeSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsGaugeChartProps,
    EchartsGaugeFormData,
    GaugeChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import { convertToHexColor } from '../../utils';
  
export default function transformProps(
    chartProps: EchartsGaugeChartProps,
): GaugeChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      gradeLabel1,
      gradeLabel2,
      gradeLabel3,
      gradeLabel4,
      gradeColor1,
      gradeColor2,
      gradeColor3,
      gradeColor4,
      threshold2,
      threshold3,
      threshold4,
      rangeMin,
      rangeMax,
      showLegend
    }: EchartsGaugeFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
  
    const { setDataMask = () => {} } = hooks;

    const seriesData = data.map(datum => {
      return {
        name: metricLabel,
        value: datum[metricLabel]
      };
    });

    const seriesMax = parseInt(rangeMax, 10);
    const seriesMin = parseInt(rangeMin, 10);
    const threshold4Val = parseInt(threshold4, 10);
    const threshold3Val = parseInt(threshold3, 10);
    const threshold2Val = parseInt(threshold2, 10);
    const label4Offset = (threshold4Val / 200) * seriesMax;
    const label3Offset = (((threshold3Val - threshold4Val) / 200) * seriesMax) + (threshold4Val / 100) * seriesMax;
    const label2Offset = (((threshold2Val - threshold3Val) / 200) * seriesMax) + (threshold3Val / 100) * seriesMax;
    const label1Offset = (((100 - threshold2Val) / 200) * seriesMax) + (threshold2Val / 100) * seriesMax;    

    const series: GaugeSeriesOption[] = [
      {
        name: metricLabel,
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        center: ['50%', '75%'],
        radius: '90%',
        min: seriesMin,
        max: seriesMax,
        splitNumber: 8,
        axisLine: {
          lineStyle: {
            width: 6,
            color: [
              [threshold4Val / 100, convertToHexColor(gradeColor4)],
              [threshold3Val / 100, convertToHexColor(gradeColor3)],
              [threshold2Val / 100, convertToHexColor(gradeColor2)],
              [1, convertToHexColor(gradeColor1)]
            ]
          }
        },
        pointer: {
          icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
          length: '12%',
          width: 20,
          offsetCenter: [0, '-60%'],
          itemStyle: {
            color: 'inherit'
          }
        },
        axisTick: {
          length: 12,
          lineStyle: {
            color: 'inherit',
            width: 2
          }
        },
        splitLine: {
          length: 20,
          lineStyle: {
            color: 'inherit',
            width: 5
          }
        },
        axisLabel: {
          color: '#464646',
          fontSize: 20,
          distance: -120,
          formatter: (value) => {
            let label = '';
            if (value === label1Offset) {
              label = gradeLabel1;
            } else if (value === label2Offset) {
              label = gradeLabel2;
            } else if (value === label3Offset) {
              label = gradeLabel3;
            } else if (value === label4Offset) {
              label = gradeLabel4;
            }
            return label;
          }
        },
        title: {
          offsetCenter: [0, '-10%'],
          fontSize: 20
        },
        detail: {
          fontSize: 30,
          offsetCenter: [0, '-35%'],
          valueAnimation: true,
          color: 'inherit'
        },
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      legend: {
        show: showLegend
      },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      groupby
    };
}
  